import React from 'react';

import * as s from './RealtorRatingBodyLayout.css';

interface IRealtorRatingBodyLayout {
  header: React.ReactNode;
  filterFields: React.ReactNode;
  tableRows: React.ReactNode;
}

/**
 * Декоратор для компонентов body в Layout'е рейтинга риелторов
 */
export const RealtorRatingBodyLayout = ({ header, filterFields, tableRows }: IRealtorRatingBodyLayout) => (
  <div className={s['wrapper']}>
    <div className={s['header-wrapper']}>{header}</div>
    <div className={s['filter-wrapper']}>{filterFields}</div>
    <div className={s['table-wrapper']}>
      <table className={s['table']}>
        <colgroup>
          <col span={1} />
          <col span={1} style={{ minWidth: '250px' }} />
          <col span={7} />
        </colgroup>

        {tableRows}
      </table>
    </div>
  </div>
);
